import {raf, rafCancel} from "./raf";

function throttle(func) {
    let requestId, args, context;

    const later = function() {
        requestId = null;
        func.apply(context, args);
        if (!requestId) {
        context = args = null;
        }
    };

    const throttled = function throttled() {
        context = this;
        args = arguments;
        if (!requestId) {
        requestId = raf(later);
        }
    };

    throttled.cancel = function() {
        return rafCancel(requestId);
    };

    return throttled;
}

const START_STICKIN = 100;

export default function stickyNav() {
    const nav = document.getElementById('gh-head');

    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', throttle(function() {
        const scrollY = window.scrollY;

        // Stick the nav
        if (scrollY < lastScrollY && scrollY < START_STICKIN) {
            nav.classList.remove('gh-head-stuck');
        } else if (scrollY > lastScrollY && scrollY > START_STICKIN) {
            nav.classList.add('gh-head-stuck');
        }

        // Save this for next tick
        lastScrollY = scrollY;
    }));
}
